<template>
  <div>
    <v-layout row>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-toolbar-title>Expedientes</v-toolbar-title>
            <v-divider class="mx-2" inset vertical></v-divider>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            >
            </v-text-field>

            <!-- <v-menu bottom left>
                            <v-btn
                                slot="activator"
                                dark
                                icon>
                                <v-icon color="black">more_vert</v-icon>
                            </v-btn>

                            <v-list>
                                <v-list-tile
                                    v-if="searchOptions === 1"
                                    @click="searchOptions = 0">
                                    <v-list-tile-title>Expediente</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile
                                    v-if="searchOptions === 0"
                                    @click="searchOptions = 1">
                                    <v-list-tile-title>Catastro</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu> -->

            <v-spacer></v-spacer>

            <v-btn fab dark :color="temaColor">
              <v-icon @click="addExpediente = !addExpediente" dark>add</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <!-- Opciones Menu -->
            <div class="text-xs-center">
              <v-menu offset-y>
                <v-btn slot="activator" :color="temaColor" dark>
                  <v-badge color="purple">
                    <span slot="badge" v-if="totalFiltros > 0">{{
                      totalFiltros
                    }}</span>
                    <span>Menú Opciones</span>
                  </v-badge>
                </v-btn>
                <v-list>
                  <v-list-tile
                    v-for="tile in opcionesMenu.tiles"
                    :key="tile.title"
                    @click="opcionesMenuAction(tile.action)"
                  >
                    <v-list-tile-title>{{ tile.title }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
              <!-- <v-bottom-sheet v-model="opcionesMenu.sheet">
                                <v-btn
                                    slot="activator"
                                    :color="temaColor"
                                    dark>
                                    Menú Opciones
                                </v-btn>

                                <v-list>
                                    <v-subheader>Menú Opciones</v-subheader>
                                    <v-list-tile
                                        v-for="tile in opcionesMenu.tiles"
                                        :key="tile.title"
                                        @click="opcionesMenuAction(tile.action)">
                                    <v-list-tile-avatar>
                                        <v-avatar size="32px" tile>
                                        <img
                                            :src="`https://cdn.vuetifyjs.com/images/bottom-sheets/${tile.img}`"
                                            :alt="tile.title"
                                        >
                                        </v-avatar>
                                    </v-list-tile-avatar>
                                    <v-list-tile-title>{{ tile.title }}</v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-bottom-sheet> -->
            </div>
          </v-card-title>

          <v-card-text>
            <v-data-table
              rows-per-page-text="Resultados por página"
              v-model="selected"
              :headers="expedientesControl.headers"
              :items="expedientesFilter"
              :search="search"
              :pagination.sync="pagination"
              select-all
              item-key="idx"
              class="elevation-1"
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <!-- <th>
                                <v-checkbox
                                    :input-value="props.all"
                                    :indeterminate="props.indeterminate"
                                    primary
                                    hide-details
                                    @click.native="toggleAll"
                                ></v-checkbox>
                                </th> -->
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                      'column sortable',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : ''
                    ]"
                    @click="changeSort(header.value)"
                  >
                    <v-icon small>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <tr
                  :active="props.selected"
                  @click="props.selected = !props.selected"
                >
                  <!-- <td>
                                <v-checkbox
                                    :input-value="props.selected"
                                    primary
                                    hide-details
                                ></v-checkbox>
                                </td> -->
                  <td>{{ props.item.detalle.nombreComunidad || "-" }}</td>
                  <td :class="statusForm(props.item.detalle.refCatastro)">{{ props.item.detalle.customId || "-" }}</td>
                  <td>{{ props.item.detalle.refCatastro || "-" }}</td>
                  <td>
                    {{ provinciaText(props.item.detalle.provincia) || "-" }}
                  </td>
                  <td>
                    {{ gestoresObject[props.item.detalle.gestor] || "-" }}
                  </td>
                  <td>{{ props.item.detalle.fecha }}</td>
                  <td>
                    {{ adminfincasObject[props.item.detalle.admon] || "-" }}
                  </td>
                  <td>{{ props.item.detalle.status }}</td>
                  <td class="text-xs-right">
                    <a
                      v-if="props.item.idx"
                      class="btn btn-outline-primary btn-sm no-decoration"
                      role="button"
                      @click="editarExpediente(props.item.idx)"
                    >
                      <v-icon class="mr-2" color="primary">create</v-icon>
                    </a>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <template v-if="false">
        <pre>{{ staticsFormsDetails }}</pre>
      </template>
    </v-layout>

    <new-expediente
      :externalActivator="true"
      :externalActived="addExpediente"
      v-on:closeNew="addExpediente = false"
    >
    </new-expediente>

    <!-- Filtros -->
    <v-dialog v-model="expteFilteredDialog" max-width="500px">
      <!-- <v-btn slot="activator" color="primary" dark class="mb-2">
                Filtros
            </v-btn> -->
      <v-card>
        <v-card-title>
          <div>
            <div class="headline">Configurar Filtros</div>
            <span class="grey--text"
              >{{ expedientesFilter.length }} Registros coincidentes</span
            >
          </div>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-combobox
                  v-model="expedientesFilterOption.provincia"
                  :items="expedientesFilterProvincias"
                  item-text="text"
                  item-value="value"
                  label="Provincia"
                  multiple
                >
                </v-combobox>
              </v-flex>
              <v-flex xs12>
                <v-combobox
                  v-model="expedientesFilterOption.gestor"
                  :items="expedientesFilterGestor"
                  label="Gestor"
                  multiple
                >
                </v-combobox>
              </v-flex>
              <v-flex xs12>
                <v-combobox
                  v-model="expedientesFilterOption.admon"
                  :items="expedientesFilterAdmon"
                  label="Administrador"
                  multiple
                >
                </v-combobox>
              </v-flex>
              <v-flex xs12>
                <v-combobox
                  v-model="expedientesFilterOption.status"
                  :items="expedientesFilterStatus"
                  label="Estado"
                  multiple
                >
                </v-combobox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="expteFilteredDialog = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-dialog v-model="subirArchivosCatastro" max-width="500px">
            <v-card>
                <v-card-title>
                    <div>
                        <div class="headline">Subir Archivo .XML del Catastro</div>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-flex xs12>
                                    <h2 class="blue--text  font-weight-light pb-2">Selecciona los Archivos para subir</h2>
                                    <input accept="application/vnd.ms-excel, text/xml" class="font-weight-light" type="file"  @change="onFileChange">
                                </v-flex>
                                <v-flex xs12>
                                    <v-list>
                                        <v-list-tile
                                            v-for="tile in filesSubida"
                                            :key="tile.idx"
                                            @click="removeFile(tile.idx)">
                                        <v-list-tile-avatar>
                                            <v-icon class="red white--text">delete_outline</v-icon>
                                        </v-list-tile-avatar>
                                        <v-list-tile-title>{{ tile.name }}</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" @click.native="submitFiles">Subir</v-btn>
                    <v-btn color="blue darken-1" flat @click.native="subirArchivosCatastro = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> -->

    <admin-file-up
      :openDialog="subirArchivosCatastro"
      v-on:closeDialog="subirArchivosCatastro = false"
    ></admin-file-up>
  </div>
</template>

<script>
// import COMPONENTE from './COMPONENTE'
import NewExpediente from "../admin/expedientes-new";
// import AdminFileUp from './admin-fileup-v2.vue'
import AdminFileUp from "./admin-fileup.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ListaExpedientes",
  components: {
    NewExpediente,
    AdminFileUp
  },
  data() {
    return {
      subirArchivosCatastro: false,
      FilesUpSelected: [],
      addExpediente: false,
      subMenu: {
        items: [
          { title: "Expediente", action: "nada" },
          { title: "Catastro", action: "nada" },
          { title: "Click Me", action: "nada" },
          { title: "Click Me 2", action: "nada" }
        ]
      },
      search: "",
      expteFilteredDialog: false,
      expteFilteredList: true,
      expedientesFilterOption: {
        provincia: [],
        gestor: [],
        admon: [],
        status: []
      },
      expedientesControl: {
        headers: [
          {
            text: "Nombre",
            align: "left",
            value: "detalle.nombreComunidad",
            sortable: true
          },
          {
            text: "Id",
            align: "left",
            value: "detalle.customId",
            sortable: true
          },
          {
            text: "Catastro",
            align: "left",
            value: "detalle.refCatastro",
            sortable: true
          },
          {
            text: "Provincia",
            align: "left",
            value: "detalle.provincia",
            sortable: true
          },
          {
            text: "Gestor",
            align: "left",
            value: "detalle.gestor",
            sortable: true
          },
          {
            text: "Fecha",
            align: "left",
            value: "detalle.timeStamp",
            sortable: true
          },
          {
            text: "Administrador",
            align: "left",
            value: "detalle.admon",
            sortable: true
          },
          {
            text: "Estado",
            align: "left",
            value: "detalle.status",
            sortable: true
          },
          {
            text: "Editar",
            align: "right",
            value: "name",
            sortable: false
          } /* ,
                    { text: 'Borrar', align: 'right', value: 'name', sortable: false } */
        ]
      },
      searchOptions: 0,
      pagination: {
        sortBy: "name"
      },
      selected: [],
      /* headers: [
                {
                text: 'Dessert (100g serving)',
                align: 'left',
                value: 'name'
                },
                { text: 'Calories', value: 'calories' },
                { text: 'Fat (g)', value: 'fat' },
                { text: 'Carbs (g)', value: 'carbs' },
                { text: 'Protein (g)', value: 'protein' },
                { text: 'Iron (%)', value: 'iron' }
            ], */
      opcionesMenu: {
        sheet: false,
        tiles: [
          { img: "keep.png", title: "Filtros", action: "filtros" },
          { img: "inbox.png", title: "Archivos Catastro", action: "subeFile" }
        ]
      },
      menuNuevoExpediente: {
        expteFilteredDialog: false
      }
    };
  },
  watch: {
    pagination(newPag, oldPag) {
      if (newPag !== oldPag) {
        this.navegationControl.expedientesList.pagination = newPag;
      }
    },
    expedientesFilterOption(newFiltro, oldFiltro) {
      if (newFiltro !== oldFiltro) {
        this.navegationControl.expedientesList.filtros = newFiltro;
      }
    },
    search(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.navegationControl.expedientesList.search = newVal;
      }
    },

    staticsFormsDetails(newVal) {
      // console.log(newVal);
      /**
       * Ahora mismo esta la franja amarilla o verde.
        Si lo pasamos al tipo listado de INMUEBLES, esos códigos de colores se pueden adoptar en el fondo del nombre del piso /escalera.

        Por ejemplo en blanco si no se ha enviado ni siquiera el link.
        - En amarillo si se le ha enviado, pero no se ha recibido contestación ninguna.
        - En azul si se ha recibido alguna contestación, pero esta pendiente de validar (igual que cuando se marcaba que cumplía por ejemplo lo de empadronamiento pero no se tenía el volante) Si hay varias personas en la propiedad, con que haya alguno con la validación pendiente.
        - En verde cuando están todos los datos recibidos validados.

        Que se pueda realizar filtro al listado por esas condiciones.
       */
    }
    /* filterProvincias(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.navegationControl.expedientesList.filtros.provincia = newVal
            }
        } */
  },
  mounted() {
    console.log('Montando lista-expedientes');
    // Actualiza las estadísticas de los formularios
    this.staticsForms();

    if (this.navegationControl.expedientesList.pagination) {
      this.pagination = this.navegationControl.expedientesList.pagination;
    } else {
      this.pagination.rowsPerPage = this.pagination.totalItems;
      // this.navegationControl.expedientesList.pagination = this.pagination
    }
    if (this.navegationControl.expedientesList.filtros) {
      this.expedientesFilterOption = this.navegationControl.expedientesList.filtros;
    }
    if (this.navegationControl.expedientesList.search) {
      this.search = this.navegationControl.expedientesList.search;
    }
  },
  created() {},
  computed: {
    ...mapGetters(["navegationControl", "staticsFormsDetails", "staticsFormsResume"]),
    
    totalFiltros() {
      let counter = 0;
      const keysFilter = Object.keys(this.expedientesFilterOption);
      for (const key of keysFilter) {
        counter += this.expedientesFilterOption[key].length;
      }
      return counter;
    },
    filterProvincias() {
      return this.expedientesFilterOption.provincia;
    },
    temaColor() {
      return this.$store.getters.getTemaColorAdminUI;
    },
    filesSubida() {
      if (this.FilesUpSelected) {
        let result = [];
        for (let index = 0; index < this.FilesUpSelected.length; index++) {
          const element = this.FilesUpSelected[index];
          result.push({
            idx: index,
            name: element.name
          });
        }
        return result;
        /* return this.FilesUpSelected.map((file, i) => {
                    return {
                        idx: i,
                        name: file.name
                    }
                }) */
      }
      return [];
    },
    searchOpciones() {
      let result = "Buscar Expedientes";
      if (this.searchOptions === 1) {
        result = "Buscar Referencia Catastral";
      }
      return result;
    },
    municipioSelect() {
      return this.$store.getters.getMunicipiosSelect;
    },
    provinciaSelect() {
      return this.$store.getters.getProvinciasSelect;
    },
    users() {
      return this.$store.getters.getUsers;
    },
    usersPreReg() {
      return this.$store.getters.getUsersPreReg;
    },
    expteStatus() {
      return this.$store.getters.getExpedientesStatus;
    },
    expedientes() {
      return this.$store.getters.getExpedientesActivos;
    },
    uid() {
      return this.$store.getters.getUserUid;
    },
    usersFilterd() {
      let result = this.usuariosList;
      if (this.usersFilteredList) {
        if (this.usersFilterOption.rol.length > 0) {
          result = result.filter(
            item => this.usersFilterOption.rol.indexOf(item.rol) > -1
          );
        }
      }
      return result;
    },
    usersFiltersRol() {
      if (this.usuariosList) {
        return this.usuariosList.map(item => item.rol).filter(this.onlyUnique);
      }
      return ["Sin resultados"];
    },
    usersArray() {
      return this.$store.getters.getUsersArray;
    },
    adminfincasObject() {
      return this.$store.getters.getAdminFincasObject;
    },
    adminfincas() {
      return this.$store.getters.getAdminFincas; // getAdminFincas
    },
    gestoresObject() {
      return this.$store.getters.getGestoresObject;
    },
    gestores() {
      return this.$store.getters.getGestores;
    },
    catastroFilter() {
      let result = this.catastroSelected ? this.catastroSelected.inmuebles : [];
      const uso = this.catastroFilterOption.uso;
      const propietario = this.catastroFilterOption.propietario;
      if (this.catastroFilteredList) {
        if (result.length > 0 && uso.length > 0) {
          result = result.filter(item => uso.indexOf(item.uso) > -1);
        }
        if (result.length > 0 && propietario.length > 0) {
          const propi = propietario.map(item =>
            item.id ? item.id : "Sin Asignar"
          );
          result = result.filter(
            item =>
              (item.propietario === "" && propi.indexOf("Sin Asignar") > -1) ||
              propi.indexOf(item.propietario) > -1
          );
        }
      }
      return result;
    },
    catastroFilterPre() {
      // pre-registrar usuario
      let result = this.catastroSelected ? this.catastroSelected.inmuebles : [];
      result = result.filter(item => item.propietario === "");
      const uso = this.catastroFilterOption.uso;
      // const propietario = this.catastroControl.tableOption === 1 ? [{id:false}] : this.catastroFilterOption.propietario
      if (this.catastroFilteredList) {
        if (result.length > 0 && uso.length > 0) {
          result = result.filter(item => uso.indexOf(item.uso) > -1);
        }
        // if (result.length > 0 && propietario.length > 0) {
        // const propi = propietario.map(item => item.id ? item.id : 'Sin Asignar')
        // result = result.filter(item => (item.propietario === '' && propi.indexOf('Sin Asignar') > -1) || propi.indexOf(item.propietario) > -1)
        // }
      }
      return result;
    },
    inmueblesFiltersUso() {
      if (this.catastroSelected) {
        return this.catastroSelected.inmuebles
          .map(item => item.uso)
          .filter(this.onlyUnique);
      }
      return ["Sin resultados"];
    },
    inmueblesFiltersPropietarioNamed() {
      return this.inmueblesFiltersPropietario.map(item => {
        return {
          id: item !== "Sin Asignar" ? item : false,
          name: item !== "Sin Asignar" ? this.userUid2Name(item) : "Sin Asignar"
        };
      });
    },
    inmueblesFiltersPropietario() {
      if (this.catastroSelected) {
        const result = ["Sin Asignar"];
        const filter = this.catastroSelected.inmuebles
          .map(item => item.propietario)
          .filter(item => item.length > 0)
          .filter(this.onlyUnique);
        const salida = result.concat(filter);
        return salida;
      }
      return ["Sin resultados"];
    },
    expedientesFiltersAplicados() {
      let result = this.expedientesFilterOption.provincia.slice();
      result = result.concat(this.expedientesFilterOption.gestor.slice());
      result = result.concat(this.expedientesFilterOption.admon.slice());
      result = result.concat(this.expedientesFilterOption.status.slice());
      return this.expteFilteredList ? result : [];
    },
    expedientesFilterProvincias() {
      // return this.expedientes.map(item => item.detalle.provincia).filter(this.onlyUnique)
      const prov = this.expedientes
        .map(item => item.detalle.provincia)
        .filter(this.onlyUnique);
      return this.provinciaSelect.filter(item => prov.indexOf(item.value) > -1);
    },
    expedientesFilterGestor() {
      return this.expedientes
        .map(item => this.gestoresObject[item.detalle.gestor] || "Sin Gestor")
        .filter(this.onlyUnique);
    },
    expedientesFilterAdmon() {
      return this.expedientes
        .map(
          item =>
            this.adminfincasObject[item.detalle.admon] || "Sin Administrador"
        )
        .filter(this.onlyUnique);
    },
    expedientesFilterStatus() {
      return this.expedientes
        .map(item => item.detalle.status)
        .filter(this.onlyUnique);
    },
    expedientesFilter() {
      let result = this.expedientes;
      let provincias =
        this.expedientesFilterOption.provincia.length > 0
          ? this.expedientesFilterOption.provincia.map(item => item.value)
          : [];
      let gestores = this.expedientesFilterOption.gestor;
      let admones = this.expedientesFilterOption.admon;
      let status = this.expedientesFilterOption.status;
      if (this.expteFilteredList) {
        if (provincias.length > 0) {
          result = result.filter(
            item => provincias.indexOf(item.detalle.provincia) > -1
          );
        }
        if (gestores.length > 0) {
          result = result.filter(
            item =>
              (!item.detalle.gestor && gestores.indexOf("Sin Gestor") > -1) ||
              gestores.indexOf(this.gestoresObject[item.detalle.gestor]) > -1
          );
        }
        if (admones.length > 0) {
          result = result.filter(
            item =>
              (!item.detalle.admon &&
                admones.indexOf("Sin Administrador") > -1) ||
              admones.indexOf(this.adminfincasObject[item.detalle.admon]) > -1
          );
        }
        if (status.length > 0) {
          result = result.filter(
            item => status.indexOf(item.detalle.status) > -1
          );
        }
      }
      return result;
    },
    usuariosList() {
      return this.$store.getters.getUsersList;
    },
    userChange() {
      return this.usuario.notas === this.originalUser.notas;
    }
  },
  methods: {
    ...mapActions(["staticsForms"]),

    statusForm(refCat) {
      if (!this.staticsFormsDetails) {
        return '';
      }
      const select = this.staticsFormsDetails[`${refCat}`] || false;
      if (!select) {
        return '';
      }
      let result = 'blue';
      const keys = Object.keys(select);
      let totalProp = 0;
      let totalNoMostrar = 0;
      keys.forEach(key => {
        const datos = select[key];
        totalProp += datos.totalUsuarios;
        totalNoMostrar += datos.noMostrar;
      });
      const diferencia = totalProp - totalNoMostrar;
      if (diferencia <= 0) {
       result = 'green';
      }
      return result;
    },

    statusForm_old(refCat) {
      if (!this.staticsFormsDetails) {
        return '';
      }
      const select = this.staticsFormsDetails[`${refCat}`] || false;
      if (!select) {
        return '';
      }
      let result = 'blue';
      const keys = Object.keys(select);
      let totalProp = 0;
      let totalCons = 0
      keys.forEach(key => {
        const datos = select[key];
        totalProp += datos.propietarios.length;
        totalCons += datos.consolidados.length;
      });
      const diferencia = totalProp - totalCons;
      if (diferencia <= 0) {
       result = 'green';
      }
      return result;
    },

    provinciaText(prov) {
      return this.provinciaSelect
        .filter(item => item.value === prov)
        .map(item => item.text)[0];
    },
    opcionesMenuAction(action) {
      if (action) {
        switch (action.toLowerCase()) {
          case "filtros":
            this.expteFilteredDialog = !this.expteFilteredDialog;
            break;
          case "subefile":
            this.subirArchivosCatastro = !this.subirArchivosCatastro;
            break;
          default:
            break;
        }
      }
      this.opcionesMenu.sheet = false;
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.FilesUpSelected = files;
      /* for (let index = 0; index < this.FilesUpSelected.length; index++) {
                const element = this.FilesUpSelected[index];
                // eslint-disable-next-line
                console.log(element.name)
            } */
    },
    removeFile(idx) {
      // eslint-disable-next-line
            console.log(idx)
      let result = [];
      for (let index = 0; index < this.FilesUpSelected.length; index++) {
        const element = this.FilesUpSelected[index];
        if (index !== idx) {
          result.push(element);
        }
      }
      this.FilesUpSelected = result;
      /* let elements = this.FilesUpSelected
            elements.splice(idx, 1)
            this.FilesUpSelected = elements */
    },
    submitFiles() {
      if (this.FilesUpSelected.length) {
        if (
          !this.FilesUpSelected.type.startsWith("application/vnd.ms-excel") &&
          !this.FilesUpSelected.type.startsWith("text/xml")
        ) {
          alert(`El formato del archivo seleccionado no es válido.
                    Sólo se admiten archivos Excell del tipo XML.`);
          return;
        }
        const filename = this.FilesUpSelected.name;
        const userUid = this.uid;
        const storageRef = this.$storage.ref();
        // const extensionFile = filename.substring(filename.lastIndexOf('.') + 1, filename.length) || ''
        // const myStorage = storageRef.child(`${userUid}/${filename}`) // this.fileUp.name
        const myStorage = storageRef.child(`${userUid}/${filename}`);
        const meta = {
          customMetadata: {
            originalName: filename,
            originalType: this.FilesUpSelected.type,
            client: userUid
          }
        };
        myStorage
          .put(this.FilesUpSelected, meta)
          .then(snapshot => {
            // eslint-disable-next-line
                        console.log(snapshot)
            /* this.virtualResult = snapshot
                        this.endSubmit()
                        myStorage.getDownloadURL().then(url => {
                            this.userDocuments.push({
                                description: this.filedescription,
                                url: url,
                                idx: false,
                                name: 'Guardando...'
                            })
                        }) */
          })
          .catch(error => {
            // eslint-disable-next-line
                        console.log(error)
            /* this.virtualResult = {
                            error: error
                        } */
            // consoleLog('Error al subir archivo')
            // consoleLog(error)
          });
      }
    },
    editarExpediente(idx) {
      // this.expedienteSelected = this.expedientes.filter(expte => expte.idx === idx)[0]
      // localStorage._GA_expteSelec = JSON.stringify(this.expedienteSelected)
      let ruta = `/dashboard/expedientes-edit/${idx}`; //
      // eslint-disable-next-line
            console.log(ruta)
      this.$router.push(ruta);
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    nada() {},
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.desserts.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    }
  }
};
</script>
